import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard, FileText, Building2 } from 'lucide-react';
import { useEstablishmentAuth } from '../../context/EstablishmentAuthContext';
import './establishment.css';

function EstablishmentLayout() {
  const { adminDoc, signOut: doSignOut } = useEstablishmentAuth();
  const nav = useNavigate();

  const handleSignOut = async () => {
    await doSignOut();
    nav('/etablissement/login', { replace: true });
  };

  return (
    <div className="est-shell">
      <aside className="est-sidebar">
        <div className="est-brand">
          <img src="/favicon.ico?v=2" alt="CrousRadar" />
          <div>
            <strong>CrousRadar</strong>
            <span>Espace Établissement</span>
          </div>
        </div>

        <nav className="est-nav">
          <NavLink to="/etablissement/gestion" end>
            <LayoutDashboard size={18} /> Dashboard
          </NavLink>
          <NavLink to="/etablissement/gestion/logs">
            <FileText size={18} /> Logs d'activité
          </NavLink>
        </nav>

        <div className="est-user">
          <div className="est-user-card">
            <div className="est-user-avatar">
              <Building2 size={20} />
            </div>
            <div className="est-user-info">
              <strong>{adminDoc?.name || adminDoc?.email || 'Admin'}</strong>
              <span>
                {adminDoc?.role === 'super' ? 'Super-admin' : 'Admin établissement'}
              </span>
            </div>
          </div>
          <button type="button" className="est-signout" onClick={handleSignOut}>
            <LogOut size={16} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="est-main">
        <Outlet />
      </main>
    </div>
  );
}

export default EstablishmentLayout;
